'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _pop = require('unmutable/lib/pop');

var _pop2 = _interopRequireDefault(_pop);

var _update = require('unmutable/lib/update');

var _update2 = _interopRequireDefault(_update);

var _pipe = require('unmutable/lib/util/pipe');

var _pipe2 = _interopRequireDefault(_pipe);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
    var fn = (0, _pop2.default)();
    return (0, _pipe2.default)((0, _update2.default)('value', fn), (0, _update2.default)('child', fn));
};


//////////////////
// WEBPACK FOOTER
// ./~/parcels/lib/parcelData/pop.js
// module id = 750
// module chunks = 35783957827783